export default __webpack_public_path__ + "images/JW.1fb178b.png";